export const SITE_URL = 'https://www.nexageapps.com';
export const GA_MEASUREMENT_ID = 'G-LJD9EKGGRS';

export const APP_PATHS = {
  intwise: '/intwise/',
  yaazh: '/apps/yaazh/',
  'qr-scan-pro': '/apps/qr-scan-pro/',
  'lucky-coin-flip': '/apps/lucky-coin-flip/',
  kiara: '/apps/kiara/',
  'open-pdf-hub': '/apps/open-pdf-hub/',
  structify: '/apps/structify/',
  aircanvas: '/apps/aircanvas/'
};

export const APP_SEO_KEYS = {
  intwise: 'intwise',
  yaazh: 'yaazh',
  'qr-scan-pro': 'qrScanPro',
  'lucky-coin-flip': 'luckyCoinFlip',
  kiara: 'kiara',
  'open-pdf-hub': 'openPDFHub',
  structify: 'structify',
  aircanvas: 'airCanvas'
};

export const APP_SHORT_NAMES = {
  intwise: 'intwise',
  yaazh: 'Yaazh',
  'qr-scan-pro': 'QR Scan Pro',
  'lucky-coin-flip': 'Lucky Flipper',
  kiara: 'Kiara',
  'open-pdf-hub': 'OpenPDF Hub',
  structify: 'Structify',
  aircanvas: 'AirCanvas'
};

export const REDIRECTS = [
  { from: '/privacypolicy', to: '/privacy/' },
  { from: '/cookiepolicy', to: '/cookies/' },
  { from: '/learnai', to: '/learn-ai/' },
  { from: '/apps/intwise', to: '/intwise/' }
];

export const absoluteUrl = (path = '/') => {
  if (!path || path === '/') {
    return `${SITE_URL}/`;
  }
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const appPath = (appId) => APP_PATHS[appId] || `/apps/${appId}/`;

export const appCanonical = (appId) => absoluteUrl(appPath(appId));
